<template>
    <div class="drag-pipeline-row" :id="item._id" :class="[checked && 'selected']">
        <div v-if="item.attachments.length > 0 && (item.coverPhoto || (item.attachments[0].ext === 'png' || item.attachments[0].ext === 'jpg' || item.attachments[0].ext === 'jpeg'))" id="image-preview" @click="view">
            <img
                v-if="item.coverPhoto"
                :src="getCoverPhotoUrl()"
                alt="attachment"
            />
            <img
                v-else
                :src="getAttachmentUrl()"
                alt="attachment"
            />
        </div>
        <div class="drag-pipeline-row-card" :type="pipeline.type">
            <div class="row-check">
                <a-checkbox class="kanban-checkbox" :checked="checked" @change="(e) => check(e)" />
            </div>

            <div class="content" @click="view">
                <div class="visitor-task" v-if="item.relations.some((relation) => relation.type === 'visitor')">
                    <PlatformIconViewer
                        :platform="getVisitorPlatform()"
                        style="width: 15px; height: 15px; align-items: normal"
                    />
                    <span>{{ getVisitorFullname() }}</span>
                </div>
                <div class="task-head">
                    <div class="task-title">
                        {{ item.title }}
                    </div>
                    <div style="width: 80px;display: flex;justify-content: center;gap: 3px;align-items: center;">
                        <span class="material-icons" style="color: #f06a52;font-size: small;">fingerprint</span>
                        <span style="font-size: x-small;font-weight: bold;">{{ item.customId }}</span>
                    </div>
                    <div
                        v-if="item.endDate"
                        class="task-more material-icons"
                        v-tippy="{
                            content: timeDifference.message,
                            placement: 'top',
                            theme: 'light',
                        }"
                        :style="{ color: timeDifference.color }"
                    >
                        schedule
                    </div>
                    <a-popover
                        @click.stop="handleInnerClick"
                        overlayClassName="task-more-options"
                        trigger="click"
                        placement="bottomRight"
                        class="kanban-task-edit-popover"
                        v-model:visible="showPopover"
                    >
                        <div slot="content">
                            <template v-for="(action, index) of actions" v-if="isShowingAction(action)">
                                <div class="bracket" v-if="index !== 0"></div>
                                <div class="options-item" @click="runAction(action.action, item)">
                                    <div class="material-icons">{{ action.icon }}</div>
                                    {{ action.text }}
                                </div>
                            </template>
                        </div>
                        <div class="task-more material-icons">more_vert</div>
                    </a-popover>
                </div>
                <div class="task-tag">
                    <div
                        v-for="tag in item.tags"
                        :key="tag._id"
                        :style="getTagStyle(tag.color)"
                        class="tag-item"
                        v-tippy="{ content: tag.name, placement: 'top' }"
                    >
                        {{ tag.name }}
                    </div>
                </div>
                <div class="kanban-task-details" @click="view">
                    <div class="task-users">
                        <div style="margin-right: 10px; display: flex" v-if="getAssigneesUserId(item).length > 0">
                            <template v-for="(userId, index) in getAssigneesUserId(item)">
                                <Avatar
                                    v-if="index < 2"
                                    :size="25"
                                    :key="userId"
                                    :src="users[userId] && users[userId].gravatar"
                                    :username="users[userId] && users[userId].name"
                                    v-tippy="{
                                        followCursor: true,
                                        placement: 'bottom-end',
                                    }"
                                    :content="users[userId] && users[userId].email"
                                    style="margin-right: -8px"
                                />
                                <div v-else-if="index === 2" class="more-avatars">
                                    +{{ getAssigneesUserId(item).length - 2 }}
                                </div>
                            </template>
                        </div>
                        <div style="display: flex; align-items: center; gap: 4px;">
                            <LowIcon v-if="item.priority === 'low'" />
                            <LowestIcon v-else-if="item.priority === 'lowest'" />
                            <MediumIcon v-else-if="item.priority === 'medium'" />
                            <HighIcon v-else-if="item.priority === 'high'" />
                            <HighestIcon v-else-if="item.priority === 'highest'" />
                            <span 
                                v-if="item.attachments.length > 0"
                                class="material-icons attachment-indicator" 
                                v-tippy="{
                                    content: 'Bu görevde dosya mevcuttur',
                                    placement: 'top',
                                    theme: 'light',
                                }"
                            >
                                attach_file
                            </span>
                        </div>
                    </div>
                    <div class="kanban-task-alt-items">
                        <template v-for="(userId, index) in getUserId(item)">
                            <Avatar
                                v-if="index < 2"
                                :size="25"
                                :key="userId"
                                :src="users[userId] && users[userId].gravatar"
                                :username="users[userId] && users[userId].name"
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                }"
                                :content="users[userId] && users[userId].email"
                            />
                            <div v-else-if="index === 2" class="more-avatars">+{{ getUserId(item).length - 2 }}</div>
                        </template>
                        <div class="kanban-task-alt-items-item" v-if="(item.subTasks || []).length > 0">
                            <div class="material-icons">chat</div>
                        </div>
                        <div class="kanban-task-alt-items-item" v-if="(item.subTasks || []).length > 0">
                            <div class="material-icons">account_tree</div>
                            {{ getCompletedParentTaskCount(item) }}/{{ (item.subTasks || []).length }}
                        </div>
                        <div class="kanban-task-alt-items-item" v-if="item.checklist.length > 0">
                            <div class="material-icons">library_add_check</div>
                            {{ getCompletedChecklistCount(item) }}/{{ item.checklist.length }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Avatar from "vue-avatar";
import { mapActions, mapGetters, mapState } from "vuex";
import _ from "lodash";
import LowIcon from "../../../../components/svg/task/LowIcon.vue";
import LowestIcon from "../../../../components/svg/task/LowestIcon.vue";
import MediumIcon from "../../../../components/svg/task/MediumIcon.vue";
import HighIcon from "../../../../components/svg/task/HighIcon.vue";
import HighestIcon from "../../../../components/svg/task/HighestIcon.vue";
import { PERMISSION_TYPES } from "../../../../language/permissionTypes";
import PlatformIconViewer from "../../../../components/common/PlatformIconViewer.vue";

export default {
    name: "TaskCard",
    props: {
        item: {
            type: Object,
            default: {},
        },
        pipeline: {
            type: Object,
            default: {},
        },
        workflowId: {
            type: String,
            default: null,
        },
        checked: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Avatar,
        LowIcon,
        LowestIcon,
        MediumIcon,
        HighIcon,
        HighestIcon,
        PlatformIconViewer,
    },
    data: () => ({
        showPopover: false,
        relations: {},
    }),
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc[user._id] = user;
                    return acc;
                }, {}),
            workflows: (state) =>
                state.tasks.workflows.reduce((acc, workflow) => {
                    acc[workflow._id] = workflow;
                    return acc;
                }, {}),
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),

        actions() {
            const actions = [
                {
                    icon: "edit",
                    text: this.$t("settings.edit"),
                    action: "edit",
                },
                {
                    icon: "delete",
                    text: this.$t("chatbotv2.delete"),
                    action: "deleteTaskModalOpen",
                },
                // {
                //     type: "goto_message",
                //     icon: "forward",
                //     text: this.$t("task.goToMessage"),
                //     action: "gotoMessage",
                // },
                // {
                //     type: "goto_chat",
                //     icon: "forward",
                //     text: this.$t("task.goToChat"),
                //     action: "gotoChat",
                // },
                {
                    type: "goto_visitor",
                    icon: "forward",
                    text: this.$t("task.showVisitor"),
                    action: "showVisitor",
                },
                {
                    icon: "archive",
                    text: this.$t("task.moveToArchive"),
                    action: "archived",
                },
                {
                    icon: "forward",
                    text: this.$t("task.changeWorkflow"),
                    action: "changeWorkflow",
                },
            ];
            if (this.pipeline.type !== "completed") {
                actions.push({
                    icon: "next_plan",
                    text: this.$t("task.completeTask"),
                    action: "toCompleted",
                });
            }
            if (this.pipeline.type === "completed") {
                actions.push({
                    icon: "check_circle",
                    text: this.$t("task.closeTheTask"),
                    action: "confirmModelOpen",
                });
            }

            return actions;
        },
        timeDifference() {
            const now = new Date();
            const endDate = new Date(this.item.endDate);
            const diffTime = endDate - now;
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            let message = "";
            let color = "#15cfae";

            if (diffDays > 0) {
                message = `${diffDays} days left`;
            } else if (diffDays === 0) {
                message = "Last day";
            } else {
                message = `${Math.abs(diffDays)} days overdue`;
                color = "#f9724d";
            }

            return { message, color };
        },
    },
    methods: {
        getCoverPhotoUrl() {
            if (!this.item.coverPhoto) return '';
            return this.item.coverPhoto.cdnUrl || `https://static.supsis.live/${this.item.coverPhoto.path + this.item.coverPhoto._id}.${this.item.coverPhoto.ext}`;
        },
        getAttachmentUrl() {
            if (!this.item.attachments || !this.item.attachments[0]) return '';
            const attachment = this.item.attachments[0];
            return attachment.v2Format && attachment.cdnUrl
                ? attachment.cdnUrl
                : attachment.cdnUrl || `https://static.supsis.live/${attachment.path + attachment._id}.${attachment.ext}`;
        },
        ...mapActions({
            addNewWindow: "app/addNewWindow",
        }),
        getAssigneesUserId(item) {
            // item.collaborators, item.followers,item.owner
            return _.uniq([item.assignees].flat()).filter((c) => this.users[c]);
        },
        getUserId(item) {
            return _.uniq([item.collaborators, item.followers, item.owner].flat()).filter((c) => this.users[c]);
        },
        getCompletedParentTaskCount(item) {
            return (item.subTasks || []).filter((item) => item.completed).length;
        },
        getCompletedChecklistCount(item) {
            return item.checklist.filter((item) => item.isCompleted).length;
        },
        view() {
            const workflow = this.workflows[this.workflowId];
            const permissions = ["createTask", "editTask", "draggingTask", "deleteTask"].map(
                (permission) => workflow.permissions[permission]
            );
            const perm = permissions.every((permission) => permission.length === 0);
            if (perm || permissions[1].includes(this.user._id)) {
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        taskId: this.item._id,
                        workflow: this.workflowId,
                        type: "kanban",
                    },
                });

                this.addNewWindow({
                    type: "editor-task",
                    title: this.item.title,
                    payload: {
                        taskId: this.item._id,
                    },
                });
            } else {
                this.addNewWindow({
                    type: "preview-task",
                    title: this.item.title,
                    payload: {
                        taskId: this.item._id,
                    },
                    footer: false,
                });
            }
        },
        check(event) {
            this.$emit("checked", {
                taskId: this.item._id,
                value: event.target.checked,
            });
        },
        edit() {
            const workflow = this.workflows[this.workflowId];
            const permissions = ["createTask", "editTask", "draggingTask", "deleteTask"].map(
                (permission) => workflow.permissions[permission]
            );
            const perm = permissions.every((permission) => permission.length === 0);
            if (perm || permissions[1].includes(this.user._id)) {
                this.addNewWindow({
                    type: "editor-task",
                    title: this.item.title,
                    payload: {
                        taskId: this.item._id,
                    },
                });
            } else {
                this.addNewWindow({
                    type: "preview-task",
                    title: this.item.title,
                    payload: {
                        taskId: this.item._id,
                    },
                    footer: false,
                });
            }
            // this.addNewWindow({
            //     type: "edit-task",
            //     payload: {
            //         taskId: this.item._id,
            //     },
            // });
            this.showPopover = false;
        },
        deleteTaskModalOpen(item) {
            this.$emit("delete-item", item);
            this.showPopover = false;
        },
        confirmModelOpen(item) {
            this.$emit("confirm-item", item);
            this.showPopover = false;
        },
        archived(item) {
            this.$emit("archived-item", item);
            this.showPopover = false;
        },
        changeWorkflow(item) {
            this.$emit("change-workflow", item);
            this.showPopover = false;
        },
        toCompleted(item) {
            this.$emit("to-completed", item);
            this.showPopover = false;
        },
        isShowingAction(action) {
            return (
                !action?.type ||
                (action.type === "goto_message" && this.relations["message"]) ||
                (action.type === "goto_chat" && this.relations["conversation"]) ||
                (action.type === "goto_visitor" && this.relations["visitor"])
            );
        },
        gotoMessage(item) {
            this.showPopover = false;
            // go to archive
        },
        gotoChat(item) {
            this.showPopover = false;
        },
        showVisitor(item) {
            this.addNewWindow({
                type: "show-visitor",
                payload: {
                    visitorId: this.relations["visitor"].visitor,
                },
                footer: false,
            });
            this.showPopover = false;
        },
        runAction(fnName, item) {
            this[fnName](item);
        },
        handleInnerClick(e) {
            e.stopPropagation();
        },
        getTagStyle(color) {
            if (!color) {
                return {
                    backgroundColor: '#f5f5f5',
                    color: '#666666',
                    borderColor: '#e0e0e0',
                };
            }
            
            const textColor = this.getContrastColor(color);
            const bgColor = this.lightenColor(color, 0.85);
            const borderColor = this.lightenColor(color, 0.6);
            
            return {
                backgroundColor: bgColor,
                color: textColor,
                borderColor: borderColor,
            };
        },
        getContrastColor(hexColor) {
            const hex = hexColor.replace('#', '');
            const r = parseInt(hex.substr(0, 2), 16);
            const g = parseInt(hex.substr(2, 2), 16);
            const b = parseInt(hex.substr(4, 2), 16);
            
            const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
            
            if (luminance > 0.6) {
                return this.darkenColor(hexColor, 0.7);
            } else if (luminance > 0.4) {
                return this.darkenColor(hexColor, 0.5);
            } else {
                return hexColor;
            }
        },
        darkenColor(color, percent) {
            const num = parseInt(color.replace("#", ""), 16);
            const amt = Math.round(2.55 * percent * 100);
            const R = Math.max((num >> 16) - amt, 0);
            const G = Math.max(((num >> 8) & 0x00ff) - amt, 0);
            const B = Math.max((num & 0x0000ff) - amt, 0);
            return "#" + (0x1000000 + R * 0x10000 + G * 0x100 + B).toString(16).slice(1);
        },
        lightenColor(color, percent) {
            if (!color) {
                return "#ffffff";
            }
            const num = parseInt(color.replace("#", ""), 16),
                amt = Math.round(2.55 * percent * 100),
                R = (num >> 16) + amt,
                G = ((num >> 8) & 0x00ff) + amt,
                B = (num & 0x0000ff) + amt;
            return (
                "#" +
                (
                    0x1000000 +
                    (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
                    (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
                    (B < 255 ? (B < 1 ? 0 : B) : 255)
                )
                    .toString(16)
                    .slice(1)
            );
        },
        getVisitorPlatform() {
            const visitorRelation = this.item.relations.find((relation) => relation.type === "visitor");
            return visitorRelation?.visitor?.platform || "";
        },
        getVisitorFullname() {
            const visitorRelation = this.item.relations.find((relation) => relation.type === "visitor");
            return visitorRelation?.visitor?.fullname || "";
        },
    },
    mounted() {
        this.relations = this.item.relations.reduce((acc, relation) => {
            acc[relation.type] = relation;
            return acc;
        }, {});
    },
};
</script>
<style lang="scss" scoped>
.more-avatars {
    display: inline-block;
    background-color: #e0e0e0;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    text-align: center;
    line-height: 25px;
    font-size: 12px;
    color: #555;
}

.task-tag {
    display: flex;
    flex-wrap: nowrap;
    overflow: hidden;
    gap: 5px;
    margin-top: 5px;
}

.tag-item {
    display: inline-block;
    padding: 1px 6px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    border: 1.5px solid;
    letter-spacing: 0.3px;
}

.visitor-task {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 5px;
    margin-top: 5px;
    line-height: 1;


    :deep(svg) {
        width: 15px;
        height: 15px;
    }

    span {
        font-size: 14px;
        color: #55555a;
    }
}

.task-more-options {
    padding-top: 0 !important;

    .ant-popover-arrow {
        display: none !important;
    }

    .ant-popover-inner-content {
        box-shadow: none !important;
    }

    .ant-popover-inner-content {
        padding: 5px 0px;
    }

    .options-item {
        width: 200px;
        display: flex;
        align-items: center;
        padding: 5px 10px;
        gap: 10px;
        font-weight: 500;
        font-size: 15px;
        color: #55555a;
        cursor: pointer;

        &:hover {
            background-color: #f1f3f9;
        }

        .material-icons {
            color: #91a2b6;
        }
    }

    .bracket {
        width: 100%;
        height: 1px;
        margin: 3px 0px;
        background-color: #e6e9f2;
    }
}

.drag-pipeline-row:hover {
    border-radius: 4px !important;
    border: 2px solid var(--pipeline-color) !important;
}

#image-preview {
    cursor: pointer;
    width: auto;
    height: 100px;
    margin-bottom: -10px;
    border-radius: 2px;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    
}

.attachment-indicator {
    color: #91a2b6 !important;
    font-size: 14px !important;
    cursor: pointer;
    transition: color 0.2s ease;
    
    &:hover {
        color: #667eea !important;
    }
}
</style>
<style lang="scss">
.visitor-task {
    .platform-icon {
        width: 15px !important;
        height: 15px !important;
        .icon {
            width: 15px !important;
            height: 15px !important;
            object-fit: contain;
        }
    }

}
</style>
